// extracted by mini-css-extract-plugin
module.exports = {"bottomBar":"BottomBar_bottomBar__HDYSv","fixed":"BottomBar_fixed__in1Kr","hide":"BottomBar_hide__7f_og","bottomBarContent":"BottomBar_bottomBarContent__4kSL3"};